import { render, staticRenderFns } from "./EmailNotConfirmedAlert.vue?vue&type=template&id=aefc18ae&scoped=true&"
import script from "./EmailNotConfirmedAlert.vue?vue&type=script&lang=js&"
export * from "./EmailNotConfirmedAlert.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotConfirmedAlert.vue?vue&type=style&index=0&id=aefc18ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefc18ae",
  null
  
)

export default component.exports